<template>
  <el-dialog
    v-loading.fullscreen.lock="loading"
    width="60%"
    title=""
    :visible.sync="innerVisible"
    append-to-body
    :close-on-click-modal="false"
    :close-on-press-escape="false"
  >
    <el-row style="text-align: center">
      <vue-qr :text="qrUrl.url" :size="300"></vue-qr>
      <p>请使用“手机浏览器”或“捷算App”扫码支付，支付完成后请点击下面确认付款按钮</p>
      <el-button @click="surePay">确认付款</el-button>
    </el-row>
  </el-dialog>
</template>

<script  >
import VueQr from 'vue-qr'
export default {
  name: 'payQrcode',
  props: {
    qrUrl: {
      url: '',
      id: '',
    },
    id: '',
  },
  watch: {
    qrUrl: {
      handler(newVal, oldVal) {
        if (newVal.url) {
          this.innerVisible = true
        }
      },
    },
  },
  components: {
    VueQr,
  },
  data() {
    return {
      innerVisible: false,
      loading: false,
    }
  },
  methods: {
    async surePay() {
      this.loading = true
      await this.$api.apply
        .confirm({ id: this.qrUrl.id })
        .then((res) => {
          if (res.code === 1000) {
            this.innerVisible = false
            this.$message.success('支付成功')
            this.$emit('JSpayStatus', true)
          }
        })
        .catch((error) => {})
        .finally(() => {
          this.loading = false
        })
    },
  },
}
</script>

<style lang="scss" scoped></style>
